import React from 'react'
import { withSiteData } from 'react-static'
import Helmet from 'react-helmet'

export default ({ page }) => (
    withSiteData(({ title }) => {
        const fullTitle = title + ((page != null) ? ' - ' + page : '')

        return <Helmet title={fullTitle} />
    })()
)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Title.js